import {
    getProductJson,
    getStepTypes,
    getProductFromUrl
} from "./parts/utilities";
import { setState, state } from "./parts/state";
import bb from "blingblingjs";
import "./parts/ui-general";
import { getInitialStepData } from "./parts/createStepData";

if (bb(".add-to-basket")[0]) {
    const { productHandle, variant, initialStepChoices } = getProductFromUrl();

    getProductJson(productHandle) 
        .then(product => {
            let _variant = variant || product.meta.selected_variant || null;

            const { newChosenOptions, newStepData } = getInitialStepData(
                product,
                _variant,
                initialStepChoices
            );
            setState({
                ...state,
                chosenOptions: newChosenOptions,
                stepData: newStepData,
                product
            });
        });
}
